import {useTranslation} from "react-i18next";
import {Card} from "antd";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import {DataGridProvider} from "../../core/components/data-grid/DataGridContext";
import LogGrid from "../../app/log/log-data-grid/LogGrid";
import LogFilter from "../../app/log/log-data-grid/LogFilter";
import CardTitle from "../../core/components/CardTitle";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";
import GridFilterCard from "../../core/components/data-grid/GridFilterCard";

export default function LogGridPage()
{
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('Logs')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <>
            <DataGridProvider>
                <LogGridContent />
            </DataGridProvider>
        </>
    )
}

function LogGridContent() {
    const {t} = useTranslation();

    return (
        // Filtre az alanlı: yan panel yerine grid'in üstünde ayrı kart.
        <LayoutWithSider fullWidth={true}>
            <GridFilterCard>
                <LogFilter />
            </GridFilterCard>
            <Card title={<CardTitle title={t('Logs')} />}>
                <LogGrid />
            </Card>
        </LayoutWithSider>
    )
}
